<div class="mobileSeparator d-none"></div>
<div id="locationContainer" class="container">

  <div class="row">
    <div class="col-xl-5 activities">
      <div class="row justify-content-center">
        <h2>Location, location, location</h2>
      </div>
      <h3 class="mb-0">{{ 'locationPage.activitiesTitle' | translate }}</h3>
      <div class="smallSeparator d-none"></div>
      <ngu-carousel #myCarousel [inputs]="carouselConfig" [dataSource]="carouselItems">
        <div *nguCarouselDef="let item;" class="item">
          <div class="tile">
            <div class="mt-3" id="locationImg">
              <img src="assets/images/activities/{{item}}.jpg" alt="" width="409px">
            </div>
            <ul class="myPoint" NguCarouselPoint>
              <li *ngFor="let i of myCarousel.pointNumbers; let j = index" [class.active]="j==myCarousel.activePoint"
                (click)="myCarousel.moveTo(j)"></li>
            </ul>
            <div class="activityText mt-2 mobDiv text-justify">
              <p>{{ item | translate }}</p>
            </div>
          </div>
        </div>
        <button NguCarouselNext class="fas fa-chevron-right arrow rightRs"></button>
        <button NguCarouselPrev class="fas fa-chevron-left arrow leftRs"></button>
      </ngu-carousel>

    </div>
    <div class="col-xl-7 map">
      <h3>{{ 'locationPage.mapTitle' | translate }}</h3>
      <div class="smallSeparator d-none"></div>
      <iframe class="mt-2" width="590" height="310" frameborder="0" style="border:0" allowfullscreen
        src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d8955.54202871392!2d-82.3504043960427!3d23.13899823986566!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88cd79bd05d9ed9b%3A0x6c73226f1da072c2!2sB%26B+de+lujo+Habana+412!5e0!3m2!1ses-419!2sar!4v1563826088033!5m2!1ses-419!2sar"></iframe>
      <div class="mt-3">
        <app-airbnb-button></app-airbnb-button>
      </div>
    </div>
  </div>
</div>